import type { ProspectResponse } from '@common/types/prospects';
import { getPracticeAreaLabel } from '@common/util';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Breadcrumbs, Chip, Link, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { convertUTCDateToEST } from '@/utils/datetime';

interface Props {
    idvDetails?: ProspectResponse;
}

export default function StandAloneIDVHeader({ idvDetails }: Props) {
    const navigate = useNavigate();
    const theme = useTheme();

    const convertedEST = idvDetails?.createdAt
        ? convertUTCDateToEST(idvDetails.createdAt, 'M/d/yyyy h:mm a')
        : '';

    return (
        <Box
            sx={{
                padding: '24px',
                height: '100%',
                boxSizing: 'border-box',
                backgroundColor: '#FFFFFF',
            }}
        >
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" sx={{ color: 'neutral.gray' }} />}
            >
                <Link
                    key={'prospects'}
                    underline="none"
                    sx={{
                        fontSize: 14,
                        fontWeight: 400,
                        color: 'neutral.gray',
                        lineHeight: '20px',
                        padding: '0px',
                        cursor: 'pointer',
                    }}
                    onClick={() => navigate('/idv')}
                >
                    IDV
                </Link>
                <Typography
                    key={'prospectName'}
                    variant="body2"
                    sx={{
                        color: 'text.primary',
                        fontWeight: 500,
                    }}
                >
                    {idvDetails?.prospectName}
                </Typography>
            </Breadcrumbs>
            <Typography sx={{ marginBottom: '8px' }} variant="h1">
                {idvDetails?.prospectName}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                }}
            >
                <Chip
                    sx={{
                        borderRadius: '5px',
                        backgroundColor: theme.palette.sidenav.main,
                        color: '#FFFFFF',
                    }}
                    label={getPracticeAreaLabel(idvDetails?.practiceArea)}
                />
                <Typography>
                    Created on:{' '}
                    <span style={{ fontWeight: 500, color: theme.palette.sidenav.main }}>
                        {convertedEST}
                    </span>{' '}
                </Typography>
            </Box>
        </Box>
    );
}
